export default __webpack_public_path__ + "static/media/pg.21b04494.svg";